import { getView, requireAuth } from '@/lib/utils';
import { UserCreatePage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/users/create',
  component: getView('pages/PageUserEdit'),
  name: 'createNewUser',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Users > Create New',
    leftMenu: Left.UsersList,
    roles: ['operator'],
    information: UserCreatePage,
    showBottomMenu: true,
  },
};
